import { render, staticRenderFns } from "./PlummInvoiceCalculator.vue?vue&type=template&id=00635880&scoped=true"
import script from "./PlummInvoiceCalculator.vue?vue&type=script&lang=js"
export * from "./PlummInvoiceCalculator.vue?vue&type=script&lang=js"
import style0 from "./PlummInvoiceCalculator.vue?vue&type=style&index=0&id=00635880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00635880",
  null
  
)

export default component.exports